module.exports = __webpack_public_path__ + "static/media/google-calendar.91c74796.svg";